<div class="job-role-selected-container">
    @if(selectedcertifiableRoles && selectedcertifiableRoles.length>0){
    <div class="sub-container">
        <div class="title">
            Selected Certifiable Roles
        </div>
        <div class="content">
            @for (item of selectedcertifiableRoles; track idx; let idx = $index) {
            <mat-chip (removed)="removeItem('certifiableRoles',item)">
                {{ item|camelCase }}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            }
        </div>
    </div>
    }
    @if(selectedNonCertifiableRoles && selectedNonCertifiableRoles.length>0){
    <div class="sub-container"
        [ngClass]="(selectedcertifiableRoles && selectedcertifiableRoles.length>0) ? 'gap':''">
        <div class="title">
            Selected Non Certifiable Roles
        </div>
        <div class="content">
            @for (item of selectedNonCertifiableRoles; track idx; let idx = $index) {
            <mat-chip (removed)="removeItem('nonCertifiableRoles',item)">
                {{ item |camelCase }}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            }
        </div>
    </div>
    }
    @if(showJobRoleContainer){
    <app-distribution-list-checkbox [dynamicFormArray]="dynamicFormArray"
        (selectionChange)="handleSelectionChange($event)" [changedField]="changedField"
        (closeCliked)="onCloseClicked()"></app-distribution-list-checkbox>
    }
</div>